export class CpeDetalle {
    Codigo_Producto : number = 0;
    Descripcion : string;
    Unidad_Medida : string;
    Cantidad : number = 1;
    Valor_Unitario : number = 0;
    Valor_Venta : number = 0;
    IGV_Importe : number = 0;
    Precio_Venta : number = 0;
    SubTotal : number = 0;
    Codigo_Tributo : number = 0;
    IGV_Afectacion : number = 0;
    IGV_Porcentaje : any = 0;
    Total : number = 0;
    Valor_Unitario_IGV : number = 0;
  }